import React, { useEffect, useState } from 'react';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import '../../styles/EmployeeMaster.css';
import '../../components/EmployeeTable.css';
import '../../components/tablestyle.css';
// import tostify for notifications if needed
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';

const DoctorsShiftMaster = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const token = sessionStorage.getItem('token');
     const [shiftList, setShiftList] = useState([]);
     const [loading, setLoading] = useState(true);
     const [search, setSearch] = useState('');
     const [itemsPerPage, setItemsPerPage] = useState(10);
     const [currentPage, setCurrentPage] = useState(1);

     // Modal state
     const [showModal, setShowModal] = useState(false);
     const [formData, setFormData] = useState({
          shift_name: '',
          in_time: '',
          out_time: '',
          total_hours: '',
          total_minutes: '',
          grace_in: '',
          grace_out: '',
          exemption_limit: '',
          status: 'A'
     });
     const [isSaving, setIsSaving] = useState(false);

     const [showEditModal, setShowEditModal] = useState(false);
     const [editFormData, setEditFormData] = useState({
          shift_name: '',
          in_time: '',
          out_time: '',
          total_hours: '',
          total_minutes: '',
          grace_in: '',
          grace_out: '',
          exemption_limit: '',
          status: 'A'
     });
     const [editId, setEditId] = useState(null);


     const fetchShiftList = () => {
          setLoading(true);
          fetch(`${baseUrl}/getDoctorShifts`, {
               method: 'GET',
               headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
               }
          })
               .then((res) => res.json())
               .then((data) => {
                    if (data.status && Array.isArray(data.data)) {
                         setShiftList(data.data);
                    } else {
                         setShiftList([]);
                    }
                    setLoading(false);
               })
               .catch((err) => {
                    console.error('Error fetching Doctors Shift list:', err);
                    setLoading(false);
               });
     };

     useEffect(() => {
          fetchShiftList();
     }, []);

     const handleAddClick = () => {
          setFormData({
               shift_name: '',
               in_time: '',
               out_time: '',
               status: 'A'
          });
          setShowModal(true);
     };

     const handleModalClose = () => {
          setShowModal(false);
     };

     // Add this function inside DoctorsShiftMaster component
     const calculateTotalHours = (inTime, outTime) => {
          if (!inTime || !outTime) return { hoursStr: '', minutesTotal: '' };
          const [inH, inM] = inTime.split(':').map(Number);
          const [outH, outM] = outTime.split(':').map(Number);
          const inDate = new Date(2000, 0, 1, inH, inM);
          const outDate = new Date(2000, 0, 1, outH, outM);
          let diffMs = outDate - inDate;
          if (diffMs < 0) diffMs += 24 * 60 * 60 * 1000;
          const totalMinutes = Math.floor(diffMs / (1000 * 60));
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;
          const hoursStr = `${hours}:${minutes.toString().padStart(2, '0')}`;
          return { hoursStr, minutesTotal: totalMinutes };
     };

     const handleFormChange = (e) => {
          const { name, value } = e.target;
          setFormData(prev => {
               let updated = { ...prev, [name]: value };
               if (name === 'in_time' || name === 'out_time') {
                    const { hoursStr, minutesTotal } = calculateTotalHours(
                         name === 'in_time' ? value : prev.in_time,
                         name === 'out_time' ? value : prev.out_time
                    );
                    updated.total_hours = hoursStr;
                    updated.total_minutes = minutesTotal;
               }
               return updated;
          });
     };

     const handleFormSubmit = async (e) => {
          e.preventDefault();
          setIsSaving(true);
          const payload = {
               shift_name: formData.shift_name,
               in_time: formData.in_time,
               out_time: formData.out_time,
               total_hours: formData.total_hours,      // e.g. "9:30"
               total_minutes: formData.total_minutes,  // e.g. 570
               grace_in: formData.grace_in,
               grace_out: formData.grace_out,
               exemption_limit: formData.exemption_limit,
               status: formData.status
          };
          try {
               const response = await fetch(`${baseUrl}/createDoctorShift`, {
                    method: 'POST',
                    headers: {
                         'Content-Type': 'application/json',
                         Authorization: `Bearer ${token}`
                    },

                    body: JSON.stringify(payload)
               });
               const result = await response.json();
               if (result.status) {
                    toast.success(result.message || 'Shift saved successfully!', { autoClose: 3000 });
                    setShowModal(false);
                    fetchShiftList();
               } else {
                    console.log(result.message || 'Failed to add Shift.');
               }
          } catch (error) {
               console.error('Error adding Shift:', error);

          }
          setIsSaving(false);
     };

     const handleEditFormChange = (e) => {
          const { name, value } = e.target;
          setEditFormData(prev => {
               let updated = { ...prev, [name]: value };
               if (name === 'in_time' || name === 'out_time') {
                    const { hoursStr, minutesTotal } = calculateTotalHours(
                         name === 'in_time' ? value : prev.in_time,
                         name === 'out_time' ? value : prev.out_time
                    );
                    updated.total_hours = hoursStr;
                    updated.total_minutes = minutesTotal;
               }
               return updated;
          });
     };

     const handleEditFormSubmit = async (e) => {
          e.preventDefault();
          setIsSaving(true);
          const payload = { ...editFormData, id: editId };
          try {
               const response = await fetch(`${baseUrl}/updateDoctorShiftById/${editId}`, {
                    method: 'POST',
                    headers: {
                         'Content-Type': 'application/json',
                         Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify(payload)
               });
               const result = await response.json();
               if (result.status) {
                    toast.success(result.message || 'Shift updated successfully!', { autoClose: 3000 });
                    setShowEditModal(false);
                    fetchShiftList();
               } else {
                    console.log(result.message || 'Failed to update Shift.');
               }
          } catch (error) {
               console.error('Error updating Shift:', error);

          }
          setIsSaving(false);
     };

     const handleEditClick = (id) => {
          const shift = shiftList.find(item => item.id === id);
          if (shift) {
               setEditFormData({ ...shift });
               setEditId(id);
               setShowEditModal(true);
          }
     };

     const handleDeleteClick = async (id) => {
          if (!window.confirm('Are you sure you want to delete this Shift?')) return;

          try {
               const response = await fetch(`${baseUrl}/deleteDoctorShiftById/${id}`, {
                    method: 'DELETE',
                    headers: {
                         'Content-Type': 'application/json',
                         Authorization: `Bearer ${token}`
                    },
               });

               const result = await response.json();

               if (result.status) {
                    toast.success(result.message || 'Shift deleted successfully!', { autoClose: 3000 });
                    fetchShiftList();
               } else {
                    console.log(result.message || 'Failed to delete Shift.');
               }
          } catch (error) {
               console.error('Error deleting Shift:', error);
          }
     };

     // Filtering logic
     const filteredData = shiftList.filter((item) =>
          Object.values(item)
               .join(' ')
               .toLowerCase()
               .includes(search.toLowerCase())
     );

     // Pagination logic
     const totalItems = filteredData.length;
     const totalPages = Math.ceil(totalItems / itemsPerPage);
     const startIndex = (currentPage - 1) * itemsPerPage;
     const currentData = filteredData.slice(startIndex, startIndex + itemsPerPage);

     const handlePageChange = (page) => {
          if (page >= 1 && page <= totalPages) {
               setCurrentPage(page);
          }
     };

     const exportToExcel = () => {
          if (filteredData.length === 0) {
               alert("No data to export");
               return;
          }

          const worksheet = XLSX.utils.json_to_sheet(
               filteredData.map((item, index) => ({
                    "S.No": index + 1,
                    "Shift Name": item.shift_name,
                    "Start Time": item.in_time,
                    "End Time": item.out_time,
                    "Total Hours": item.total_hours,
                    "Grace In (Minutes)": item.grace_in,
                    "Grace Out (Minutes)": item.grace_out,
                    "Exemption Limit": item.exemption_limit,
                    "Status": item.status === "A" ? "Active" : "Inactive",
                    "Created By": item.created_by,
                    "Created On": item.created_on,
                    "Modified By": item.modified_by || "-",
                    "Modified On": item.modified_on || "-",
               }))
          );

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "DoctorsShifts");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
          saveAs(blob, "Doctors_Shift_Report.xlsx");
     };

     if (loading) return <div>Loading Doctors Shift data...</div>;

     return (
          <>
               <ToastContainer position="top-right" />
               <div className="employee-master-page">
                    <div className="employee-header">
                         <h2>Doctors Shift Master</h2>
                         <button className="add-employee-btn" onClick={handleAddClick}>
                              Add Shift
                         </button>
                    </div>
                    <div className="employee-table-container" style={{ padding: "10px" }}>
                         {/* Top Controls */}
                         <div
                              className="table-controls"
                              style={{
                                   display: 'flex',
                                   justifyContent: 'space-between',
                                   alignItems: 'center',
                                   marginBottom: '15px',
                                   flexWrap: 'wrap',
                                   gap: '10px',
                                   background: '#f9f9f9',
                                   padding: '10px 15px',
                                   borderRadius: '8px',
                                   boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                              }}
                         >
                              {/* Show entries */}
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: 500 }}>
                                   Show{' '}
                                   <select
                                        value={itemsPerPage}
                                        onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                                        style={{
                                             padding: '5px 8px',
                                             borderRadius: '6px',
                                             border: '1px solid #ccc',
                                             outline: 'none',
                                             cursor: 'pointer',
                                        }}
                                   >
                                        <option value={10}>10</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                   </select>{' '}
                                   entries
                              </div>

                              {/* Search */}
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', fontWeight: 500 }}>
                                   Search:
                                   <input
                                        type="text"
                                        value={search}
                                        onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
                                        placeholder="Search Shift..."
                                        style={{
                                             padding: '5px 10px',
                                             borderRadius: '6px',
                                             border: '1px solid #ccc',
                                             outline: 'none',
                                             minWidth: '180px',
                                             boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
                                             transition: 'border 0.2s, box-shadow 0.2s',
                                        }}
                                        onFocus={(e) => e.target.style.boxShadow = '0 0 5px rgba(0,123,255,0.5)'}
                                        onBlur={(e) => e.target.style.boxShadow = 'inset 0 1px 3px rgba(0,0,0,0.05)'}
                                   />
                                   <button
                                        onClick={exportToExcel}
                                        style={{
                                             background: "#28a745",
                                             color: "#fff",
                                             padding: "6px 12px",
                                             borderRadius: "6px",
                                             border: "none",
                                             cursor: "pointer",
                                             fontWeight: 500
                                        }}
                                   >
                                        Export Excel
                                   </button>
                              </div>
                         </div>


                         <table className="employee-table">
                              <thead>
                                   <tr>
                                        <th>S.No</th>
                                        <th>Shift Name</th>
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Total Hours</th>
                                        <th>Exemption Limit</th>
                                        <th>Actions</th>
                                   </tr>
                              </thead>
                              <tbody>
                                   {currentData.length > 0 ? (
                                        currentData.map((item, index) => (
                                             <tr key={item.id}>
                                                  <td>{startIndex + index + 1}</td>
                                                  <td>{item.shift_name}</td>
                                                  <td>{item.in_time}</td>
                                                  <td>{item.out_time}</td>
                                                  <td>{item.total_hours}</td>
                                                  <td>{item.exemption_limit}</td>
                                                  <td>
                                                       <button
                                                            className="action-button edit"
                                                            onClick={() => handleEditClick(item.id)}
                                                            title="Edit"
                                                            aria-label={`Edit ${item.shift_name}`}
                                                            style={{ padding: '6px', borderRadius: '6px' }}
                                                       >
                                                            {/* Pencil / Edit SVG */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                 <path d="M12 20h9" />
                                                                 <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                                                            </svg>
                                                       </button>
                                                       <button
                                                            className="action-button delete"
                                                            onClick={() => handleDeleteClick(item.id)}
                                                            title="Delete"
                                                            aria-label={`Delete ${item.shift_name}`}
                                                            style={{ padding: '6px', borderRadius: '6px', marginLeft: '8px' }}
                                                       >
                                                            {/* Trash / Delete SVG */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                 <polyline points="3 6 5 6 21 6" />
                                                                 <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                                                 <path d="M10 11v6" />
                                                                 <path d="M14 11v6" />
                                                                 <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                                                            </svg>
                                                       </button>
                                                  </td>
                                             </tr>
                                        ))
                                   ) : (
                                        <tr><td colSpan="7" style={{ textAlign: 'center' }}>No Shift data found</td></tr>
                                   )}
                              </tbody>
                         </table>

                         {/* Bottom Controls */}
                         <div className="table-footer" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                              {/* Showing entries */}
                              <div>
                                   Showing {currentData.length > 0 ? startIndex + 1 : 0} to {startIndex + currentData.length} of {totalItems} entries
                              </div>

                              {/* Pagination */}
                              <div className="pagination">
                                   <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>{'<'}</button>
                                   {Array.from({ length: totalPages }, (_, i) => (
                                        <button
                                             key={i + 1}
                                             onClick={() => handlePageChange(i + 1)}
                                             style={{ fontWeight: currentPage === i + 1 ? 'bold' : 'normal' }}
                                        >
                                             {i + 1}
                                        </button>
                                   ))}
                                   <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>{'>'}</button>
                              </div>
                         </div>
                    </div>

                    {/* Add Shift Modal */}
                    {showModal && (
                         <div className="modal fade show" tabIndex="-1" style={{ display: 'block', background: 'rgba(0,0,0,0.4)' }}>
                              <div className="modal-dialog modal-lg">
                                   <div className="modal-content">
                                        <div className="modal-header">
                                             <h5 className="modal-title">Add Doctors Shift</h5>
                                             <button type="button" className="btn-close" onClick={handleModalClose}></button>
                                        </div>
                                        <form onSubmit={handleFormSubmit}>
                                             <div className="modal-body row p-3">
                                                  <div className="form-group mb-3 col-12">
                                                       <label>Shift Name</label>
                                                       <input
                                                            type="text"
                                                            name="shift_name"
                                                            value={formData.shift_name}
                                                            onChange={e => {
                                                                 // Convert all letters to uppercase as user types
                                                                 const value = e.target.value.toUpperCase();
                                                                 setFormData(prev => ({ ...prev, shift_name: value }));
                                                            }}
                                                            className="form-control form-control-sm"
                                                            required
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Start Time</label>
                                                       <input
                                                            type="time"
                                                            name="in_time"
                                                            value={formData.in_time}
                                                            onChange={handleFormChange}
                                                            className="form-control form-control-sm"
                                                            required
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>End Time</label>
                                                       <input
                                                            type="time"
                                                            name="out_time"
                                                            value={formData.out_time}
                                                            onChange={handleFormChange}
                                                            className="form-control form-control-sm"
                                                            required
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Grace In ( Minutes )</label>
                                                       <input type='number'
                                                            name='grace_in'
                                                            value={formData.grace_in || ''}
                                                            onChange={handleFormChange}
                                                            className='form-control form-control-sm'
                                                            placeholder='Grace In'
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Grace Out ( Minutes )</label>
                                                       <input type='number'
                                                            name='grace_out'
                                                            value={formData.grace_out || ''}
                                                            onChange={handleFormChange}
                                                            className='form-control form-control-sm'
                                                            placeholder='Grace Out'
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Total Hours</label>
                                                       <input
                                                            type='text'
                                                            name='total_hours'
                                                            value={formData.total_hours || ''}
                                                            className='form-control form-control-sm'
                                                            placeholder='Total Hours (HH:mm)'
                                                            readOnly
                                                       />
                                                       <input type='hidden'
                                                            name='total_minutes'
                                                            value={formData.total_minutes || ''}
                                                            onChange={handleFormChange}
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Exemption Limit (hours)</label>
                                                       <input
                                                            type="number"
                                                            name="exemption_limit"
                                                            value={formData.exemption_limit || ''}
                                                            onChange={handleFormChange}
                                                            className="form-control form-control-sm"
                                                            placeholder="Exemption Limit in hours (e.g. 2.5)"
                                                            step="0.1"
                                                            min="0"
                                                       />
                                                  </div>
                                             </div>
                                             <div className="modal-footer">
                                                  <button type="button" className="btn btn-secondary" onClick={handleModalClose}>
                                                       Cancel
                                                  </button>
                                                  <button type="submit" className="btn btn-primary" disabled={isSaving}>
                                                       {isSaving ? 'Saving...' : 'Save'}
                                                  </button>
                                             </div>
                                        </form>
                                   </div>
                              </div>
                         </div>
                    )}

                    {showEditModal && (
                         <div className="modal fade show" tabIndex="-1" style={{ display: 'block', background: 'rgba(0,0,0,0.4)' }}>
                              <div className="modal-dialog modal-lg">
                                   <div className="modal-content">
                                        <div className="modal-header">
                                             <h5 className="modal-title">Edit Doctors Shift</h5>
                                             <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button>
                                        </div>
                                        <form onSubmit={handleEditFormSubmit}>
                                             <div className="modal-body row p-3">
                                                  <div className="form-group mb-3 col-12">
                                                       <label>Shift Name</label>
                                                       <input
                                                            type="text"
                                                            name="shift_name"
                                                            value={editFormData.shift_name}
                                                            onChange={e => {
                                                                 const value = e.target.value.toUpperCase();
                                                                 setEditFormData(prev => ({ ...prev, shift_name: value }));
                                                            }}
                                                            className="form-control form-control-sm"
                                                            required
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Start Time</label>
                                                       <input
                                                            type="time"
                                                            name="in_time"
                                                            value={editFormData.in_time}
                                                            onChange={handleEditFormChange}
                                                            className="form-control form-control-sm"
                                                            required
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>End Time</label>
                                                       <input
                                                            type="time"
                                                            name="out_time"
                                                            value={editFormData.out_time}
                                                            onChange={handleEditFormChange}
                                                            className="form-control form-control-sm"
                                                            required
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Grace In ( Minutes )</label>
                                                       <input type='number'
                                                            name='grace_in'
                                                            value={editFormData.grace_in || ''}
                                                            onChange={handleEditFormChange}
                                                            className='form-control form-control-sm'
                                                            placeholder='Grace In'
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Grace Out ( Minutes )</label>
                                                       <input type='number'
                                                            name='grace_out'
                                                            value={editFormData.grace_out || ''}
                                                            onChange={handleEditFormChange}
                                                            className='form-control form-control-sm'
                                                            placeholder='Grace Out'
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Total Hours</label>
                                                       <input
                                                            type='text'
                                                            name='total_hours'
                                                            value={editFormData.total_hours || ''}
                                                            className='form-control form-control-sm'
                                                            placeholder='Total Hours (HH:mm)'
                                                            readOnly
                                                       />
                                                       <input type='hidden'
                                                            name='total_minutes'
                                                            value={editFormData.total_minutes || ''}
                                                            onChange={handleEditFormChange}
                                                       />
                                                  </div>
                                                  <div className="form-group mb-3 col-6">
                                                       <label>Exemption Limit (hours)</label>
                                                       <input
                                                            type="number"
                                                            name="exemption_limit"
                                                            value={editFormData.exemption_limit || ''}
                                                            onChange={handleEditFormChange}
                                                            className="form-control form-control-sm"
                                                            placeholder="Exemption Limit in hours (e.g. 2.5)"
                                                            step="0.1"
                                                            min="0"
                                                       />
                                                  </div>
                                             </div>
                                             <div className="modal-footer">
                                                  <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
                                                       Cancel
                                                  </button>
                                                  <button type="submit" className="btn btn-primary" disabled={isSaving}>
                                                       {isSaving ? 'Saving...' : 'Save'}
                                                  </button>
                                             </div>
                                        </form>
                                   </div>
                              </div>
                         </div>
                    )}
               </div>
          </>
     );
};

export default DoctorsShiftMaster;